import * as Br from '@fixtuur/brenda';
import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
import * as Canvas from './A_Canvas';

export interface Props {
    /** onReady can return a clean-up function as taken by an useEffect hook */
    onReady: (r: Br.Renderer.Renderer) => void | (() => void);
    options: Br.Options;
}

export function Component(props: Props) {
    const rendererRef = Hooks.useRef<Br.Renderer.Renderer>();

    Hooks.useEffect(() => {
        if (rendererRef.current !== undefined) {
            return props.onReady(rendererRef.current);
        }
    }, [rendererRef.current]);

    return (
        <Canvas.Component
            onReady={canvas => {
                rendererRef.current = Br.Renderer.create(canvas, props.options);
            }}
        />
    );
}

Component.displayName = 'BrendaCanvas';
